import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
// Custom Service Worker Registration for Push Notifications

// Remove initial loader function
function removeInitialLoader() {
  const loader = document.getElementById('initial-loader');
  if (loader) {
    loader.style.opacity = '0';
    setTimeout(() => {
      if (loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }, 300);
  }
}

// Register our custom service worker with push notification support
async function registerCustomServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      console.log('🔧 Registering custom service worker v4 with blank screen fixes...');
      
      // Add cache-busting parameter to force service worker update
      const swUrl = `/sw.js?v=${Date.now()}`;
      
      const registration = await navigator.serviceWorker.register(swUrl, {
        scope: '/',
        updateViaCache: 'none' // Always check for updates
      });
      
      console.log('✅ Custom Service Worker v4 registered successfully:', registration.scope);
      
      // Force immediate update check
      registration.update();
      
      // Check for updates more frequently during development
      const updateInterval = process.env.NODE_ENV === 'development' ? 60000 : 300000; // 1 min dev, 5 min prod
      setInterval(() => {
        registration.update();
      }, updateInterval);
      
      // Listen for updates
      registration.addEventListener('updatefound', () => {
        console.log('🔄 New service worker version found, updating...');
        const newWorker = registration.installing;
        
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              console.log('✅ New service worker activated');
            }
          });
        }
      });
      
      // Handle service worker errors
      registration.addEventListener('error', (error) => {
        console.error('❌ Service Worker error:', error);
        // Clear caches if service worker fails
        clearAllCaches();
      });
      
      return registration;
    } catch (error) {
      console.error('❌ Custom Service Worker registration failed:', error);
      // Clear caches if registration fails
      clearAllCaches();
    }
  } else {
    console.warn('⚠️ Service Workers not supported');
  }
}

// Function to clear all caches when service worker fails
async function clearAllCaches() {
  try {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
      console.log('🗑️ All caches cleared due to service worker issues');
    }
  } catch (error) {
    console.warn('⚠️ Failed to clear caches:', error);
  }
}

// Initialize custom service worker
registerCustomServiceWorker();


// Removed showOfflineNotification function - no longer needed

// Enhanced version checking system - enabled for production
function setupVersionChecking() {
  // Check for version updates every 5 minutes
  setInterval(async () => {
    try {
      const response = await fetch('/version.json', { 
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const currentVersion = localStorage.getItem('app-version');
        
        if (currentVersion && currentVersion !== data.version) {
          console.log('🔄 New version detected:', data.version);
          
          // Clear all caches
          if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(
              cacheNames.map(name => caches.delete(name))
            );
            console.log('🗑️ All caches cleared');
          }
          
          // Update version and reload
          localStorage.setItem('app-version', data.version);
          window.location.reload();
        } else if (!currentVersion) {
          localStorage.setItem('app-version', data.version);
        }
      }
    } catch (error) {
      console.warn('Version check failed:', error);
    }
  }, 5 * 60 * 1000); // Check every 5 minutes
}

// Initialize version checking - enabled for production
setupVersionChecking();

// Create root and render
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Remove loader after React mounts
setTimeout(removeInitialLoader, 1000);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
